import React from "react";
import ImageComponent from "components/imageComponent/ImageComponent";
import Spacer from "components/Spacer/Spacer";
import VisitSummaryContent from "components/visitSummaryAccordion/VisitSummaryContent";
import VisitSummaryContentHeading from "components/visitSummaryAccordion/VisitSummaryContentHeading";
import VisitSummaryContentParagraph from "components/visitSummaryAccordion/VisitSummaryContentParagraph";
import { primary_care_sub_steps } from "helpers/enum";
import { usePrimaryCareVisitFlow } from "hooks/useVisitFlow";
import usePatients from "hooks/visit/usePatients";
import { useDispatch } from "react-redux";
import { useHistory } from "react-router-dom";
import { primaryCareVisitFlowReducers } from "reducers/primary_care/primaryCareVisitFlowReducer";

function BasicDetailsForPCSummary({ readOnly, data }) {
  const { incompleteData, patientsList } = usePrimaryCareVisitFlow();
  const { getPatientById } = usePatients();
  const history = useHistory();
  const dispatch = useDispatch();
  return (
    <VisitSummaryContent
      readOnly={readOnly}
      onEditClick={() => {
        dispatch(
          primaryCareVisitFlowReducers.currentScreen({
            value: primary_care_sub_steps.select_patient,
          })
        );
        history.push("/visit/primary-care/new-visit");
      }}
    >
      <VisitSummaryContentHeading text="Patient Name" />
      <VisitSummaryContentParagraph
        text={
          data?.patient_name ??
          getPatientById(incompleteData?.patient_id, patientsList)?.full_name
        }
      />
      <Spacer height={20} />
      <VisitSummaryContentHeading text="State of Residence" />
      <VisitSummaryContentParagraph
        text={
          data?.state ??
          getPatientById(incompleteData?.patient_id, patientsList)?.state
        }
      />
      <Spacer height={20} />
      <VisitSummaryContentHeading text="Patient Identity" />
      <div className="pt-5">
        <ImageComponent
          url={
            data?.patient_photo_id ??
            getPatientById(incompleteData?.patient_id, patientsList)?.insurance
              ?.id_proof
          }
        />
      </div>
    </VisitSummaryContent>
  );
}

export default BasicDetailsForPCSummary;
